import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
      if ( screen.width > 768 ) {
        ScrollTrigger.create( {
          trigger: '.team-member__single',
          start: 'top top+=64px',
          end: 'bottom bottom',
          pin: '.pinned-image',
          scrub: 1,
          // markers: true,
        } );
      }
    },
  };
  app.registerComponent( 'team', COMPONENT );
} )( app );
